import { IconLoader2 } from '@tabler/icons-react';
import { cn } from '@/utils/cn';

export function Spinner({ size = 24, className }: { size?: number; className?: string }) {
  return <IconLoader2 className={cn('animate-spin text-brand-primary', className)} style={{ width: size, height: size }} />;
}

export function FullPageSpinner({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="flex h-full min-h-[40vh] flex-col items-center justify-center gap-3">
      <Spinner size={40} />
      <p className="text-sm text-text-secondary">{label}</p>
    </div>
  );
}
